"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
  _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
  _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
  _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
  _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
  _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
  _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
  _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
  _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
  _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
  _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
  _react = _interopRequireWildcard(require("react")),
  _defaults = _interopRequireDefault(require("defaults")),
  _reactFastCompare = _interopRequireDefault(require("react-fast-compare")),
  _TerminalMessage = _interopRequireDefault(require("./TerminalMessage")),
  _validateCommands = _interopRequireDefault(require("./handlers/validateCommands")),
  _scrollHistory = _interopRequireDefault(require("./handlers/scrollHistory")),
  _parseEOL = _interopRequireDefault(require("./handlers/parseEOL")),
  _Terminal = _interopRequireDefault(require("./defs/styles/Terminal")),
  _Terminal2 = _interopRequireDefault(require("./defs/types/Terminal")),
  _commandExists2 = _interopRequireDefault(require("./utils/commandExists")),
  _constructEcho = _interopRequireDefault(require("./utils/constructEcho")),
  _shouldPromptBeVisible = _interopRequireDefault(require("./utils/shouldPromptBeVisible"));
function _getRequireWildcardCache(a) {
  if ("function" != typeof WeakMap) return null;
  var b = new WeakMap(),
    c = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(a) {
    return a ? c : b;
  })(a);
}
function _interopRequireWildcard(a, b) {
  if (!b && a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    default: a
  };
  var c = _getRequireWildcardCache(b);
  if (c && c.has(a)) return c.get(a);
  var d = {},
    e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var f in a) if ("default" != f && Object.prototype.hasOwnProperty.call(a, f)) {
    var g = e ? Object.getOwnPropertyDescriptor(a, f) : null;
    g && (g.get || g.set) ? Object.defineProperty(d, f, g) : d[f] = a[f];
  }
  return d["default"] = a, c && c.set(a, d), d;
}
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    (0, _defineProperty2["default"])(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _createSuper(a) {
  var b = _isNativeReflectConstruct();
  return function () {
    var c,
      d = (0, _getPrototypeOf2["default"])(a);
    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);
    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}
var Terminal = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "focusTerminal", function () {
      var a = "Range" === window.getSelection().type;
      a || d.terminalInput.current.focus();
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "scrollToBottom", function () {
      var a = d.terminalRoot.current;
      setTimeout(function () {
        a.scrollTop = a.scrollHeight;
      }, 1);
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "validateCommands", function () {
      var a = d.props,
        b = a.commands,
        c = a.noDefaults,
        e = a.ignoreCommandCase,
        f = (0, _validateCommands["default"])(b, d.showHelp, d.clearStdout, {
          noDefaults: c,
          ignoreCommandCase: e
        });
      d.setState({
        commands: f
      });
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "showWelcomeMessage", function () {
      var a = d.props.welcomeMessage;
      "boolean" == typeof a ? d.pushToStdout("Welcome to the React terminal! Type 'help' to get a list of commands.") : Array.isArray(a) ? a.map(function (a) {
        return d.pushToStdout(a);
      }) : d.pushToStdout(a);
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "showHelp", function () {
      var a = d.state.commands;
      for (var f in a) {
        var b = a[f],
          e = b.usage ? " - ".concat(b.usage) : "";
        d.pushToStdout("".concat(f, " - ").concat(b.description).concat(e));
      }
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "pushToStdout", function (a, b) {
      var c = d.state.stdout;
      d.props.locked && c.pop(), c.push({
        message: a,
        isEcho: (null === b || void 0 === b ? void 0 : b.isEcho) || !1
      }), null !== b && void 0 !== b && b.rawInput && d.pushToHistory(b.rawInput), d.setState({
        stdout: c
      });
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "pushToHistory", function (a) {
      var b = d.state.history;
      b.push(a), d.setState({
        history: b,
        historyPosition: null
      });
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "getStdout", function () {
      var a = d.props.noNewlineParsing ? d.state.stdout : (0, _parseEOL["default"])(d.state.stdout);
      return a.map(function (a, b) {
        return _react["default"].createElement(_TerminalMessage["default"], {
          key: b,
          content: a.message,
          dangerMode: d.props.dangerMode,
          className: a.isEcho ? void 0 : d.props.messageClassName,
          style: a.isEcho ? void 0 : d.props.messageStyle
        });
      });
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "clearStdout", function () {
      d.setState({
        stdout: []
      });
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "clearInput", function () {
      d.setState({
        historyPosition: null
      }), d.terminalInput.current.value = "";
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "processCommand", function () {
      d.setState({
        processing: !0
      }, (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
        var b, c, e, f, g, h, i, j, k, l;
        return _regenerator["default"].wrap(function (a) {
          for (;;) switch (a.prev = a.next) {
            case 0:
              if (b = {
                command: null,
                args: [],
                rawInput: null,
                result: null
              }, c = d.terminalInput.current.value, d.props.noHistory || d.pushToHistory(c), d.props.noEchoBack || d.pushToStdout((0, _constructEcho["default"])(d.props.promptLabel || "$", c, d.props), {
                isEcho: !0
              }), !c) {
                a.next = 25;
                break;
              }
              if (e = c.split(" "), f = e.splice(0, 1)[0], g = e, b.rawInput = c, b.command = f, b.args = g, h = (0, _commandExists2["default"])(d.state.commands, f, d.props.ignoreCommandCase), i = h.exists, j = h.command, i) {
                a.next = 16;
                break;
              }
              d.pushToStdout(d.props.errorText ? d.props.errorText.replace(/\[command\]/gi, j) : "Command '".concat(f, "' not found!")), a.next = 25;
              break;
            case 16:
              return k = d.state.commands[j], a.next = 19, k.fn.apply(k, (0, _toConsumableArray2["default"])(g));
            case 19:
              if (l = a.sent, d.pushToStdout(l), b.result = l, !k.explicitExec) {
                a.next = 25;
                break;
              }
              return a.next = 25, k.fn.apply(k, (0, _toConsumableArray2["default"])(g));
            case 25:
              d.setState({
                processing: !1
              }, function () {
                d.clearInput(), d.props.noAutoScroll || d.scrollToBottom(), d.props.commandCallback && d.props.commandCallback(b);
              });
            case 26:
            case "end":
              return a.stop();
          }
        }, a);
      })));
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "scrollHistory", function (a) {
      var b = d.state,
        c = b.history,
        e = b.historyPosition,
        f = b.previousHistoryPosition,
        g = (0, _scrollHistory["default"])(a, {
          history: c,
          historyPosition: e,
          previousHistoryPosition: f,
          terminalInput: d.terminalInput
        });
      g && d.setState(g);
    }), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "handleInput", function (a) {
      switch (a.key) {
        case "Enter":
          d.processCommand();
          break;
        case "ArrowUp":
          d.scrollHistory("up");
          break;
        case "ArrowDown":
          d.scrollHistory("down");
      }
    }), d.state = {
      commands: {},
      stdout: [],
      history: [],
      historyPosition: null,
      previousHistoryPosition: null,
      processing: !1
    }, d.terminalRoot = _react["default"].createRef(), d.terminalInput = _react["default"].createRef(), d;
  }
  (0, _inherits2["default"])(b, a);
  var c = _createSuper(b);
  return (0, _createClass2["default"])(b, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(a) {
      (0, _reactFastCompare["default"])(a.commands, this.props.commands) || this.validateCommands();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateCommands(), this.props.welcomeMessage && this.showWelcomeMessage(), this.props.autoFocus && this.focusTerminal();
    }
  }, {
    key: "render",
    value: function render() {
      var a = {
        container: (0, _defaults["default"])(this.props.style, _Terminal["default"].container),
        content: (0, _defaults["default"])(this.props.contentStyle, _Terminal["default"].content),
        inputArea: (0, _defaults["default"])(this.props.inputAreaStyle, _Terminal["default"].inputArea),
        promptLabel: (0, _defaults["default"])(this.props.promptLabelStyle, _Terminal["default"].promptLabel),
        input: (0, _defaults["default"])(_objectSpread(_objectSpread({}, this.props.inputStyle), this.props.inputTextStyle), _objectSpread(_objectSpread({}, _Terminal["default"].input), _Terminal["default"].inputText))
      };
      return _react["default"].createElement("div", {
        ref: this.terminalRoot,
        name: "react-console-emulator",
        className: this.props.className,
        style: a.container,
        onClick: this.focusTerminal
      }, _react["default"].createElement("div", {
        name: "react-console-emulator__content",
        className: this.props.contentClassName,
        style: a.content
      }, this.getStdout(), _react["default"].createElement("div", {
        name: "react-console-emulator__inputArea",
        className: this.props.inputAreaClassName,
        style: (0, _shouldPromptBeVisible["default"])(this.state, this.props) ? a.inputArea : {
          display: "none"
        }
      }, _react["default"].createElement("span", {
        name: "react-console-emulator__promptLabel",
        className: this.props.promptLabelClassName,
        style: a.promptLabel
      }, this.props.promptLabel || "$"), _react["default"].createElement("input", {
        ref: this.terminalInput,
        name: "react-console-emulator__input",
        className: this.props.inputClassName,
        style: a.input,
        onKeyDown: this.handleInput,
        type: "text",
        autoComplete: "off",
        disabled: this.props.disabled || this.props.disableOnProcess && this.state.processing
      }))));
    }
  }]), b;
}(_react.Component);
exports["default"] = Terminal, (0, _defineProperty2["default"])(Terminal, "propTypes", _Terminal2["default"]);